<template>
  <ModalBase 
    ref="assinaturaDigitalModal" 
    @toggleModal="afterToggleModal"
  >
    <div class="row" style="margin-bottom: 18px;">
      <div class="col-md-12">
        <h2>{{$t('Selecione o Certificado Digital:')}}</h2>
      </div>
    </div>
    <div class="row" style="margin-bottom: 18px;">
      <div class="col-md-12">
        <div v-if="certificados.length === 0">
          {{$t('Nenhum certificado digital encontrado.')}}
        </div>
        <div v-else>
          <div v-for="certificado in certificados" :key="certificado.id">
            <input 
              type="radio" 
              v-model="certificadoSelecionado" 
              class="btn-check" 
              name="certificado-selecionado" 
              :value="certificado.id" 
              :id="'kt_radio_buttons_2_option_' + certificado.id"
            />
            <label 
              class="btn btn-outline btn-outline-dashed btn-active-light-primary p-7 d-flex align-items-center mb-5" 
              :for="'kt_radio_buttons_2_option_' + certificado.id"
            >
              <i class="ki-duotone ki-document fs-4x me-4">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              <span class="d-block fw-semibold text-start">
                <span class="text-gray-900 fw-bold d-block fs-3">
                  {{ certificado.name }}
                </span>
                <span class="text-muted fw-semibold fs-6" style="display: block;">
                  {{ certificado.providerName }}
                </span>
                <span class="text-muted fw-semibold fs-7" style="display: block;">
                  Issuer: {{ GetCommonName(certificado.cert.issuerName) }}
                </span>
                <span class="text-muted fw-semibold fs-7" style="display: block;">
                  Valid: {{ formataData(certificado.cert.notBefore) }} - {{ formataData(certificado.cert.notAfter) }}
                </span>
                <span class="text-muted fw-semibold fs-7" style="display: block;">
                  Serial: {{ certificado.cert.serialNumber }}
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ButtonPadrao 
          label="Confirmar" 
          :block="true" 
          color="success" 
          :isLoading="isLoading" 
          :disabled="!certificadoSelecionado || isLoading || confirmando || assinaturaIndeterminada"
          @click="confirmarSelecao"
        />
      </div>
    </div>
    <p v-if="assinaturaIndeterminada" role="alert" class="text-warning mt-3">A assinatura não foi confirmada. Feche esta janela e confira o documento nas pendências antes de tentar novamente.</p>
  </ModalBase>
</template>

<script>
import moment from "moment";
import { markRaw } from "vue";
import { mapGetters, mapActions } from "vuex";

import ModalBase from "@/../../desk-spirit/src/components/modals/ModalBase.vue";
import ButtonPadrao from "@/../../desk-spirit/src/components/buttons/ButtonPadrao.vue";

export default {
  name: "ModalAssinaturaDigital",
  emits: ["sairModal", "assinado", "recarregarDatasAtendimento", "conclusaoEncerrada"],
  components: {
    ModalBase, 
    ButtonPadrao
  },
  data() {
    return {
      isLoading: false, 
      ws: null, 
      certificados: [], 
      certificadoSelecionado: "", 
      idAtendimento: "", 
      idPacienteLaudo: "", 
      idAtendimentoDetalhe: "", 
      sairDoAtendimento: false,
      modalAberto: false,
      confirmando: false,
      assinaturaIndeterminada: false,
      documentoAssinado: false,
      assinaturaGeracao: 0,
      assinaturaEncerrada: false,
      resolverDocumento: null
    };
  }, 
  beforeUnmount() {
    this.assinaturaEncerrada = true;
    this.afterToggleModal(false);
  }, 
  computed: {
    ...mapGetters([
      "medicoUsuario"
    ])
  }, 
  methods: {
    assinarAoFinalizar(idAtendimento) {
      if(this.modalAberto) { return; }
      this.idPacienteLaudo = "";
      this.idAtendimentoDetalhe = "";
      this.idAtendimento = idAtendimento;
      this.sairDoAtendimento = true;
      this.toggleModal();
    },
    abrirDocumento(id) {
      if(this.modalAberto || this.resolverDocumento) { return Promise.reject(new Error("Já existe uma assinatura aberta.")); }
      this.idPacienteLaudo = id;
      this.idAtendimento = "";
      this.idAtendimentoDetalhe = "";
      this.sairDoAtendimento = false;
      const resultado = new Promise(resolve => { this.resolverDocumento = resolve; });
      this.toggleModal();
      return resultado;
    },
    fecharDocumento() {
      if(this.modalAberto) { this.$refs.assinaturaDigitalModal.toggleModal(); }
    },
    ...mapActions([
      "iniciarAssinatura", 
      "iniciarAssinaturaDetalhe", 
      "completarAssinatura", 
      "completarAssinaturaDetalhe", 
      "sleepTime"
    ]), 
    toggleModal() {
      if(this.modalAberto) { this.fecharDocumento(); return; }
      this.modalAberto = true;
      this.assinaturaGeracao++;
      this.documentoAssinado = false;
      this.assinaturaIndeterminada = false;
      this.$refs.assinaturaDigitalModal.toggleModal();
      const geracao = this.assinaturaGeracao;
      this.inicializar().catch(() => {
        if(this.modalAberto && this.assinaturaGeracao === geracao) {
          this.$swal({ icon: "error", text: "Não foi possível acessar os certificados. Você pode fechar esta janela e assinar pelas pendências." });
        }
      });
    }, 
    async inicializar() {
      const geracao = this.assinaturaGeracao;
      const vigente = () => !this.assinaturaEncerrada && this.modalAberto && geracao === this.assinaturaGeracao;
      const storage = await window.WebcryptoSocket.BrowserStorage.create();
      if(!vigente()) { return; }
      const ws = markRaw(new window.WebcryptoSocket.SocketProvider({ storage }));
      this.ws = ws;
      const falhou = () => {
        if(vigente()) { this.$swal({ icon: "error", text: "Não foi possível conectar com seus certificados. Verifique se o serviço Fortify está instalado e rodando." }); }
      };
      ws.connect("127.0.0.1:31337").on("error", falhou).on("listening", async () => {
        try {
          if(!vigente()) { return; }
          const logado = await ws.isLoggedIn();
          if(!vigente()) { return; }
          if(!logado) {
            const pin = await ws.challenge();
            if(!vigente()) { return; }
            this.$swal({ icon: "info", text: "Será necessária a aprovação de conexão com o PIN: " + pin, timer: 3000 });
            await ws.login();
            if(!vigente()) { return; }
          }
          const info = await ws.info();
          if(!vigente()) { return; }
          const certificados = [];
          for(const providerInfo of info.providers) {
            const provider = await ws.getCrypto(providerInfo.id);
            if(!vigente()) { return; }
            const ids = await provider.certStorage.keys();
            if(!vigente()) { return; }
            const keys = await provider.keyStorage.keys();
            if(!vigente()) { return; }
            for(const id of ids.filter(id => id.split("-")[0] === "x509" && keys.some(key => key.split("-")[0] === "private" && key.split("-")[2] === id.split("-")[2]))) {
              let cert;
              try { cert = await provider.certStorage.getItem(id); } catch(error) { continue; }
              if(!vigente()) { return; }
              if(cert.notBefore <= new Date() && cert.notAfter >= new Date()) {
                certificados.push({ id, name: this.GetCommonName(cert.subjectName), cert, providerName: providerInfo.name });
              }
            }
          }
          if(vigente()) { this.certificados = certificados.sort((a,b) => a.name.localeCompare(b.name)); }
        } catch(error) { falhou(); }
      });
    },
    GetCommonName(name) {
      var reg = /CN=(.+),?/i;
      var res = reg.exec(name);
      return res ? res[1] : "Unknown";
    }, 
    async GetCertificateKey(type, provider, certID, algorithm, extractable, usages) {
      const keyIDs = await provider.keyStorage.keys();
      for(const keyID of keyIDs) {
        const parts = keyID.split("-");

        if(parts[0] === type && parts[2] === certID.split("-")[2]) {
          let key;
          if(algorithm && extractable !== undefined && usages) {
            key = await provider.keyStorage.getItem(keyID, algorithm, extractable, usages);
          } else {
            key = await provider.keyStorage.getItem(keyID);
          }
          if(key) {
            return key;
          }
        }
      }
      if(type === "public") {
        const cert = (algorithm && extractable !== undefined && usages)
          ? await provider.certStorage.getItem(certID, algorithm, extractable, usages)
          : await provider.certStorage.getItem(certID);
        if(cert) {
          return cert.publicKey;
        }
      }
      return null;
    }, 
    fromHex(hexString) {
      let res = new Uint8Array(hexString.length / 2);
      for (let i = 0; i < hexString.length; i = i + 2) {
        let c = hexString.slice(i, i + 2);
        res[i / 2] = parseInt(c, 16);
      }
      return res.buffer;
    }, 
    toHex(buffer) {
      let buf = new Uint8Array(buffer),
      splitter = "",
      res = [],
      len = buf.length;

      for (let i = 0; i < len; i++) {
        let char = buf[i].toString(16);
        res.push(char.length === 1 ? "0" + char : char);
      }
      return res.join(splitter);
    }, 
    formataData(data) {
      return moment(data).format("DD/MM/YYYY");
    }, 
    async confirmarSelecao() {
      if(this.isLoading || this.confirmando || this.assinaturaIndeterminada || !this.modalAberto) { return; }
      const certificado = this.certificados.find(item => item.id === this.certificadoSelecionado);
      if(!certificado) { return; }
      const geracao = this.assinaturaGeracao;
      this.confirmando = true;
      try {
        if(this.GetCommonName(certificado.cert.subjectName).split(":")[1] != String(this.medicoUsuario.CPF || "").replace(/\D/g, "")) {
          await this.$swal({ title: "Erro", text: "O certificado selecionado não pertence ao seu CPF.", icon: "error" });
          return;
        }
        const result = await this.$swal({ title: "Você tem certeza?", text: "Deseja assinar com " + this.GetCommonName(certificado.cert.subjectName) + "?",
          icon: "question", showCancelButton: true, confirmButtonText: "Sim", cancelButtonText: "Não" });
        if(result.isConfirmed && this.modalAberto && geracao === this.assinaturaGeracao) { await this.realizarAssinatura(certificado); }
      } finally { if(geracao === this.assinaturaGeracao) { this.confirmando = false; } }
    },
    async realizarAssinatura(certificado) {
      if(this.isLoading || this.assinaturaIndeterminada || !this.modalAberto) { return; }
      const geracao = this.assinaturaGeracao;
      const idLaudo = this.idPacienteLaudo, idAtendimento = this.idAtendimento;
      const vigente = () => !this.assinaturaEncerrada && this.modalAberto && geracao === this.assinaturaGeracao;
      const dados = idLaudo ? { ID_PACIENTE_LAUDO: idLaudo } : { ID_ATENDIMENTO: idAtendimento };
      let conclusaoEnviada = false;
      this.isLoading = true;
      try {
        const provider = certificado.cert.provider;
        const cert = await provider.certStorage.getItem(certificado.id);
        if(!vigente()) { return; }
        const certPem = await provider.certStorage.exportCert("pem", cert);
        if(!vigente()) { return; }
        const privateKey = await this.GetCertificateKey("private", provider, certificado.id);
        if(!vigente()) { return; }
        if(!privateKey || (!idLaudo && !idAtendimento)) { throw new Error(); }
        const iniciar = idLaudo ? this.iniciarAssinatura : this.iniciarAssinaturaDetalhe;
        const completar = idLaudo ? this.completarAssinatura : this.completarAssinaturaDetalhe;
        const inicio = await iniciar({ ...dados, certificate: certPem, useAIA: false, useTimestamp: true });
        if(!vigente()) { return; }
        if(!inicio?.resultado || !inicio.dataToSign) { throw new Error(); }
        const signature = await provider.subtle.sign({ name: privateKey.algorithm.name, hash: "SHA-256" }, privateKey, this.fromHex(inicio.dataToSign));
        if(!vigente()) { return; }
        conclusaoEnviada = true;
        const fim = await completar({ ...dados, signature: this.toHex(signature) });
        if(!vigente()) { return; }
        if(!fim?.resultado) { throw new Error(); }
        this.documentoAssinado = true;
        this.$emit("assinado", dados);
        if(idAtendimento) { this.$emit("recarregarDatasAtendimento", idAtendimento); }
        if(!this.resolverDocumento) { this.$swal({ title: "Sucesso", text: "Assinatura realizada com sucesso.", icon: "success", timer: 3000 }); }
        this.fecharDocumento();
      } catch(error) {
        if(vigente()) {
          this.assinaturaIndeterminada = conclusaoEnviada;
          this.$swal({ title: "Assinatura não concluída", icon: "warning", text: conclusaoEnviada ?
            "Não foi possível confirmar a assinatura. Confira o documento nas pendências antes de tentar novamente." :
            "Não foi possível realizar a assinatura. O documento continua disponível para assinar depois." });
        }
      } finally { if(geracao === this.assinaturaGeracao) { this.isLoading = false; } }
    },
    afterToggleModal(show) {
      if(show || !this.modalAberto) { return; }
      const id = this.idPacienteLaudo, assinado = this.documentoAssinado, resolver = this.resolverDocumento;
      const sair = this.sairDoAtendimento;
      this.modalAberto = false;
      this.assinaturaGeracao++;
      this.resolverDocumento = null;
      this.isLoading = false;
      this.confirmando = false;
      try { this.ws?.close(); } catch(error) { /* Uma conexão já encerrada não impede fechar a seleção. */ }
      this.ws = null;
      this.certificados = [];
      this.certificadoSelecionado = "";
      this.idPacienteLaudo = "";
      this.idAtendimentoDetalhe = "";
      this.idAtendimento = "";
      this.sairDoAtendimento = false;
      resolver?.({ idPacienteLaudo: id, assinado });
      this.$emit("sairModal", id);
      if(sair && !this.assinaturaEncerrada) { this.$emit("conclusaoEncerrada"); }
    },
  }
}
</script>

<style scoped>

</style>
